<!--
    Template
-->

<template>
    <div>
        <canvas ref="canvas" />
    </div>
</template>



<!--
    Scripts
-->

<script>


    // imports

    import {Chart, scaleLabels, stripedGrid, ChartDataLabels} from '@/common/modules/chart'


    // colors

    const style = getComputedStyle(document.documentElement);
    const clBlue = style.getPropertyValue('--cl-blue') || '#0081cc';
    const clBlueLight = style.getPropertyValue('--cl-blue-light') || '#e5f2f9';
    const clBlack = style.getPropertyValue('--cl-black') || '#222222';
    const clWhiteDark = style.getPropertyValue('--cl-white-dark') || '#F8FAFB';


    // config

    const config = {
        type: 'bar',
        plugins: [
            scaleLabels,
            stripedGrid,
            ChartDataLabels,

        ],
        data: {
            labels: [],
            datasets: [{
                backgroundColor: clBlueLight,
                borderColor: clBlueLight,
                hoverBackgroundColor: clBlueLight,
                hoverBorderColor: clBlueLight
            }]
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            legend: {
                display: false
            },
            scales: {
                xAxes: [{
                    gridLines: {
                        display: false
                    }
                }],
                yAxes: [{
                    id: 'count',
                    gridLines: {
                        display: false
                    },
                    ticks: {
                        beginAtZero: true
                    }
                }],
            },
            tooltips: {
                enabled: false
            },
            plugins: {
                axesLabels: {
                    labels: [{
                        fontStyle: 'bold',
                        fontColor: clBlack,
                        yAxisID: 'count',
                        value: ['件数']
                    }]
                },
                stripedGrid: {
                    yAxisID: 'count',
                    backgroundColor: clWhiteDark
                },
                datalabels: {
                    align: 'start', anchor: 'end',
                    color: clBlue,
                    font: {
                        weight: 'bold'
                    }
                }

            }
        }

    };


    export default {

        props: [
            'data'
        ],

        methods: {

            update () {
                if (!this.data) return;
                this.chart.data.labels = this.data.chartLabels;
                this.chart.data.datasets[0].data = this.data.chartValues;
                this.chart.update();
            }

        },

        watch: {

            data () {
                this.chart && this.update();
            }

        },

        mounted () {
            const ctx = this.$refs.canvas.getContext('2d');
            this.chart = new Chart(ctx, config);
            this.update();
        }

    }

</script>

